import { Box, ButtonGroup, Checkbox, FormControl } from "@primer/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { diemDanhStatusApi } from "../../../../api/diemDanhStatusApi";
import { FormGroupInline } from "../../../../components/form-group";
import Button from "../../../../components/ui/button";
import Modal from "../../../../components/ui/modal";
import TextInput from "../../../../components/ui/text-input";
import { useCommonContext } from "../../../../contexts/common";
import { NotifyHelper } from "../../../../helpers/toast";
import { useCommonSelectedHook } from "../../../../hooks/useCommonSelectedHook";
import { nt_diem_danh_trang_thai } from "../../../../models/response/category/nt_diem_danh_trang_thai";

interface ITrangThaiDetailModalProps {
	id: number;
	onClose: () => void;
	onSuccess: () => void;
}

const DiemDanhTrangThaiDetailModal = (props: ITrangThaiDetailModalProps) => {
	const [isSaving, setIsSaving] = useState(false);
	const { translate } = useCommonContext();
	const { nam_hoc, dm_coso_id } = useCommonSelectedHook();

	const [formData, setFormData] = useState<nt_diem_danh_trang_thai>({
		id: props.id,
		name: "",
		name_en: "",
		code: "",
		sort: 0,
		is_default: false
	});

	const {
		register,
		handleSubmit,
		clearErrors,
		reset,
		setError,
		control,
		setValue,
		formState: { errors },
	} = useForm<nt_diem_danh_trang_thai>({
		defaultValues: {},
	});

	useEffect(() => {
		if (props.id > 0) {
			handleGetVm();
		}
	}, [props.id]);

	const handleGetVm = async () => {
		const res = await diemDanhStatusApi.SelectById(props.id);
		if (res.is_success) {
			const data: nt_diem_danh_trang_thai = {
				...res.data,
			};
			setFormData(data);
			reset(data);
		} else {
			NotifyHelper.Error(res.message ?? "Error");
		}
	};

	const onSubmit = async (data: any) => {
		setIsSaving(true);
		let res: any;

		const submitData = {
			...data,
			is_default: formData.is_default,
			id: props.id
		};

		if (props.id > 0) {
			res = await diemDanhStatusApi.Update(submitData);
		} else {
			res = await diemDanhStatusApi.Insert(submitData);
		}

		if (res.is_success) {
			NotifyHelper.Success("Success");
			props.onSuccess();
		} else {
			NotifyHelper.Error(res.message ?? "Error");
		}
		setIsSaving(false);
	};

	return (
		<Modal
			isOpen
			onClose={props.onClose}
			// width={"60%"}
			sx={{
				width: "30%"
			}}
			title={props.id > 0 ? "Cập nhật" : "Thêm mới"}
		>
			<form onSubmit={handleSubmit(onSubmit)}>
				<div className="row">
					<div className="col-md-12 mb-3">
						<FormControl>
							<FormControl.Label>Trạng thái</FormControl.Label>
							<TextInput
								block
								name="name"
								register={register}
								errors={errors}
								required
								validateMessage="Vui lòng điền tên trạng thái"
							/>
						</FormControl>
						<FormControl>
							<FormControl.Label>Trạng thái (en)</FormControl.Label>
							<TextInput
								block
								name="name_en"
								register={register}
								errors={errors}
								required
								validateMessage="Vui lòng điền tên trạng thái tiếng anh"
							/>
						</FormControl>
						<FormControl>
							<FormControl.Label>Ký hiệu</FormControl.Label>
							<TextInput
								block
								name="code"
								register={register}
								errors={errors}
							/>
						</FormControl>
						<FormControl>
							<FormControl.Label>Thứ tự</FormControl.Label>
							<TextInput
							type="number"
								block
								name="sort"
								register={register}
								errors={errors}
							/>
						</FormControl>
						
							<div className='col-md-12'>
								<FormGroupInline label='Mặc định'>
									<Checkbox
										checked={formData.is_default}
										onChange={(e) => {
											setFormData({ ...formData, is_default: e.target.checked || false });
										}}
									/>
								</FormGroupInline>
							</div>
					</div>
				</div>
				<Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
					<ButtonGroup>
						<Button onClick={props.onClose}>{translate("Base.Label.Cancel")}</Button>
						<Button variant="primary" type="submit" disabled={isSaving}>
							{translate(props.id > 0 ? "Base.Label.Update" : "Base.Label.Create")}
						</Button>
					</ButtonGroup>
				</Box>


			</form>
		</Modal>
	);
};

export default DiemDanhTrangThaiDetailModal;
